<div class="viewport-1" [style.background-image]="'url(' + interventionTaskService.taskBackgroundImage() + ')'">
  <student-header></student-header>
  <task-bar #taskBar [totalPoints]='taskTotalPoints'></task-bar>

  <div class="task-screen-element find-the-rhyme-container"
    [style.background-image]="' ' + interventionTaskService.taskContainerColor() + ' '"
    [class]="(animationComplete || !animateContainer) ? 'taskShow' : 'taskHide'">
    <div class="testType font-18">{{interventionTaskService.testType()}}</div>
    <div class="timer-bar-container">
      <trial-timer-bar></trial-timer-bar>
      <button [class]="(hideTimer) ? 'replayVideo-no-timerbar' : 'replayVideo'"
      (click)="replayVideo()" disabled="disableVideo()"></button>
    </div>
    <div class="word-to">
      <div class="word-masked font-42">
        {{targetWord}}
      </div>
      @if (!unmaskedTask) {
        <button [class]="{ 'again-button-grayed' : disableAgainButton, 'again-button' : !disableAgainButton, 'toggle-again-on' : toggleAgainButton, 'again-button-hidden': hideAgainButton }"
          [disabled]="disableAgainButton"
          (click)="displayTrialAgain()">
        </button>
      }
    </div>
    <div class="response-row">
      @if (!unmaskedTask) {
        <button
          [class]="{'next-button-grayed' : disableNextButton, 'next-button' : !disableNextButton, 'toggle-next-on' : toggleNextButton, 'next-button-hidden': hideNextButton}"
        [disabled]="disableNextButton" (click)="displayTrial()"></button>
      }
    </div>
    @if (!hideResponses) {
      <div class="full-response-row">
        @for (response of responseOptions1; track response.text) {
          <div class="big-button-div">
            @if (!showResponseAudioButtons) {
              <button class = "rhyme-letter-audio-hidden"></button>
            }
            @if (showResponseAudioButtons) {
              <button class = "rhyme-letter-audio"
              (click)="playResponseAudio($index)" [disabled]="disableAVButtons"></button>
            }
            <button #respButton1 class="rhyme-instructional-response-block font-30"
              [class.hover]="response.highlight"
              (click)="submitResponse($index); removeHoverClass(respButton1);"
              (touchstart)="addHoverClass(respButton1)" (touchend)="removeHoverClass(respButton1)"
              (mouseenter)="addHoverClass(respButton1)" (mouseleave)="removeHoverClass(respButton1)"
              [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
              [disabled]="disableResponseButtons">
              {{response.text}}
            </button>
          </div>
        }
      </div>
    }
    @if (!hideResponses) {
      <div class="full-response-row">
        @for (response of responseOptions2; track response.text) {
          <div class="big-button-div">
            @if (!showResponseAudioButtons) {
              <button class = "rhyme-letter-audio-hidden"></button>
            }
            @if (showResponseAudioButtons) {
              <button class = "rhyme-letter-audio"
              (click)="playResponseAudio($index+3)" [disabled]="disableAVButtons"></button>
            }
            <button #respButton2 class="rhyme-instructional-response-block font-30"
              [class.hover]="response.highlight"
              (click)="submitResponse($index+3); removeHoverClass(respButton2);"
              (touchstart)="addHoverClass(respButton2)" (touchend)="removeHoverClass(respButton2)"
              (mouseenter)="addHoverClass(respButton2)" (mouseleave)="removeHoverClass(respButton2)"
              [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
              [disabled]="disableResponseButtons">
              {{response.text}}
            </button>
          </div>
        }
      </div>
    }
  </div>
  @if (isDevMode) {
    <div>{{wordListAttempt}} - {{task.wordlistType}}</div>
  }

  <trial-counter [showCorrectIncorrect]="true" [taskAnimationComplete]="animationComplete"></trial-counter>
  <instructions [videoSource]="instructionalVideoFile"></instructions>
  <save-data-dialog (onSaveButtonClick)="saveTaskData()"></save-data-dialog>
  <focus-dialog></focus-dialog>
</div>
{{runChangeDetection}}
